import { useScreenSizeStore } from 'context/ScreenSizeContext';

export function useScreenSize() {
  const { size } = useScreenSizeStore();
  return size;
}
